module.exports = __webpack_public_path__ + "img/nrsLogo.4fd68657.png";